import { gql } from '@apollo/client';

const GET_HERD_VISIBILITY_USER_SETTINGS = gql`
    query GetHerdVisibilityUserSettings($farmId: Int!) {
        getHerdVisibilityUserSettings(farmId: $farmId) {
            id
            userId
            settingsId
            farmId
            saved_settings
        }
    }
`;

export default GET_HERD_VISIBILITY_USER_SETTINGS;
